import React from 'react';
import { prohibitedIcon } from '@chordbaker/design';

interface ProhibitedIconProps {
    className?: string;
    size?: number;
    color?: string;
}

const ProhibitedIcon: React.FC<ProhibitedIconProps> = ({
    className = "h-4 w-4",
    size = 16,
    color = "currentColor"
}) => {
    const circle = prohibitedIcon.elements[0] as { cx: number; cy: number; r: number };
    const path = prohibitedIcon.elements[1] as { d: string };

    return (
        <svg
            className={className}
            width={size}
            height={size}
            xmlns="http://www.w3.org/2000/svg"
            viewBox={prohibitedIcon.viewBox}
            fill={prohibitedIcon.fill}
            stroke={color}
            strokeWidth={prohibitedIcon.strokeWidth}
            strokeLinecap={prohibitedIcon.strokeLinecap as React.SVGAttributes<SVGSVGElement>['strokeLinecap']}
            strokeLinejoin={prohibitedIcon.strokeLinejoin as React.SVGAttributes<SVGSVGElement>['strokeLinejoin']}
        >
            <circle cx={circle.cx} cy={circle.cy} r={circle.r} />
            <path d={path.d} />
        </svg>
    );
};

export default ProhibitedIcon;
